export const COMMON_SAVE_CRASH_REPORT_BEGIN = 'COMMON_SAVE_CRASH_REPORT_BEGIN';
export const COMMON_SAVE_CRASH_REPORT_SUCCESS = 'COMMON_SAVE_CRASH_REPORT_SUCCESS';
export const COMMON_SAVE_CRASH_REPORT_FAILURE = 'COMMON_SAVE_CRASH_REPORT_FAILURE';
export const COMMON_SAVE_CRASH_REPORT_DISMISS_ERROR = 'COMMON_SAVE_CRASH_REPORT_DISMISS_ERROR';
export const COMMON_LOAD_PROJECT_DETAIL_BEGIN = 'COMMON_LOAD_PROJECT_DETAIL_BEGIN';
export const COMMON_LOAD_PROJECT_DETAIL_SUCCESS = 'COMMON_LOAD_PROJECT_DETAIL_SUCCESS';
export const COMMON_LOAD_PROJECT_DETAIL_FAILURE = 'COMMON_LOAD_PROJECT_DETAIL_FAILURE';
export const COMMON_LOAD_PROJECT_DETAIL_DISMISS_ERROR = 'COMMON_LOAD_PROJECT_DETAIL_DISMISS_ERROR';
export const COMMON_LOAD_PROJECT_VERSION_BEGIN = 'COMMON_LOAD_PROJECT_VERSION_BEGIN';
export const COMMON_LOAD_PROJECT_VERSION_SUCCESS = 'COMMON_LOAD_PROJECT_VERSION_SUCCESS';
export const COMMON_LOAD_PROJECT_VERSION_FAILURE = 'COMMON_LOAD_PROJECT_VERSION_FAILURE';
export const COMMON_LOAD_PROJECT_VERSION_DISMISS_ERROR =
  'COMMON_LOAD_PROJECT_VERSION_DISMISS_ERROR';
export const COMMON_TOGGLE_DEBUG_MODE_BEGIN = 'COMMON_TOGGLE_DEBUG_MODE_BEGIN';
export const COMMON_TOGGLE_DEBUG_MODE_SUCCESS = 'COMMON_TOGGLE_DEBUG_MODE_SUCCESS';
export const COMMON_TOGGLE_DEBUG_MODE_FAILURE = 'COMMON_TOGGLE_DEBUG_MODE_FAILURE';
export const COMMON_TOGGLE_DEBUG_MODE_DISMISS_ERROR = 'COMMON_TOGGLE_DEBUG_MODE_DISMISS_ERROR';
export const COMMON_LOAD_COLLECTION_CHANGE = 'COMMON_LOAD_COLLECTION_CHANGE';
export const COMMON_RESET_COLLECTION_CHANGE = 'COMMON_RESET_COLLECTION_CHANGE';
export const COMMON_TRACK_COLLECTION_CHANGE = 'COMMON_TRACK_COLLECTION_CHANGE';
